import type { PendingProviderDocument } from '../types/providerDocument';

type ProviderKind = 'specialists' | 'consultants';

type CreateDocumentFn = (args: {
  kind: ProviderKind;
  providerId: number;
  formData: FormData;
}) => { unwrap: () => Promise<unknown> };

export async function uploadPendingProviderDocuments(
  kind: ProviderKind,
  providerId: number,
  documents: PendingProviderDocument[],
  createDocument: CreateDocumentFn,
) {
  for (const doc of documents) {
    const formData = new FormData();
    formData.append('name', doc.name);
    formData.append('file', doc.file);
    await createDocument({ kind, providerId, formData }).unwrap();
  }
}
